import { useState } from "react"
import { useSelector } from "react-redux"
import Container from "../components-layout/Container"
import WarningModal from "../components-modals/WarningModal"
import Layout from "../Layout"
import DatagridMorosidad from "./DatagridMorosidad"
import DatagridResumen from "./DatagridResumen"
import MorosidadForm from "./MorosidadForm"

const Morosidad = () => {

    const [loading, setLoading] = useState(true)
    const [rawData, setRawData] = useState([])

    const { user } = useSelector(state => state.auth)
    const userObj = JSON.parse(user) 

    return (
        <Layout userObj={userObj} activeTab="Vistas">
            <WarningModal
                open={loading ? true : false}
                image={<img src='./img/loader.gif' alt='loading' />}
                opacity='bg-opacity-100'
            />
            <Container height="h-full">
                <div className="flex flex-col gap-5">    
                    <div className="pt-5 lg:pt-0">
                        <MorosidadForm
                            setLoading={setLoading}
                            setRawData={setRawData}
                        />
                    </div>
                    <div>
                        <DatagridResumen
                            data={rawData?.Encabezado?.Sedes}
                        />
                    </div>
                    <div>
                        <DatagridMorosidad 
                            data={rawData?.Detalle}
                        />
                    </div>
                </div>
            </Container>
        </Layout>
    )
}

export default Morosidad